export default "__VITE_ASSET__CjCWSeSZ__"